import * as React from 'react'

export const READMEIcon = React.forwardRef<
  SVGSVGElement,
  {
    color?: string
    width?: number
    height?: number
  } & React.SVGProps<SVGElement>
>(({ style, ...props }, ref) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 16"
      fill="none"
      style={style}
      {...props}
      ref={ref}
    >
      <path
        fill="currentColor"
        d="M4.062 10.512c.518 0 1.022.058 1.511.176.49.117.976.301 1.458.552V5.096c-.439-.286-.914-.5-1.425-.644a5.91 5.91 0 0 0-2.594-.126 5.44 5.44 0 0 0-1.005.29.19.19 0 0 0-.102.068.175.175 0 0 0-.03.1v5.91c0 .057.02.098.06.124.04.026.084.029.132.009.297-.101.61-.179.939-.233.33-.055.681-.082 1.056-.082Zm3.907.728c.482-.25.968-.435 1.458-.552.49-.118.993-.176 1.51-.176.376 0 .728.027 1.057.082.33.054.642.132.939.233.048.02.092.017.132-.01.04-.025.06-.066.06-.123v-5.91a.16.16 0 0 0-.03-.097.231.231 0 0 0-.102-.072 5.44 5.44 0 0 0-1.005-.289 5.91 5.91 0 0 0-2.594.126 5.126 5.126 0 0 0-1.425.644v6.144ZM7.5 12.615a6.115 6.115 0 0 0-1.631-.862 5.465 5.465 0 0 0-1.807-.304 5.002 5.002 0 0 0-2.187.5.613.613 0 0 1-.636-.048.651.651 0 0 1-.302-.574V4.54c0-.135.035-.261.104-.38a.591.591 0 0 1 .3-.255 5.812 5.812 0 0 1 1.323-.457A6.613 6.613 0 0 1 4.062 3.3c.609 0 1.203.083 1.783.25.58.166 1.132.411 1.655.736a6.552 6.552 0 0 1 1.655-.736 6.438 6.438 0 0 1 1.783-.25c.473 0 .94.05 1.398.149.459.099.9.251 1.323.457.13.052.23.137.3.255.069.119.104.245.104.38v6.786a.63.63 0 0 1-.314.568.666.666 0 0 1-.66.042 5.056 5.056 0 0 0-1.049-.364 4.944 4.944 0 0 0-1.102-.124c-.622 0-1.224.102-1.807.304a6.115 6.115 0 0 0-1.631.862Z"
      />
    </svg>
  )
})
